import React from "react";
import AppBar from "@material-ui/core/AppBar";
import useScrollTrigger from "@material-ui/core/useScrollTrigger/useScrollTrigger";
import PropTypes from "prop-types";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import '../css/elevationScroll.css';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";


const theme = createMuiTheme({

    palette: {
        primary: {
            main: '#0052D4',
            blueGradient: "linear-gradient(to right, #6FB1FC, #4364F7, #0052D4)",
        },
    },
});

function ElevationScroll(props) {
    const {children, window} = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.node.isRequired,
    // Injected by the documentation to work in an iframe.
    // You won't need it on your project.
    window: PropTypes.func,
};
export default function ElevateAppBar(props) {
    return (
        <React.Fragment>
            <ElevationScroll {...props}>
                <AppBar className="AppBar bg-pan-bottom" style={{background: theme.palette.primary.blueGradient}}>
                    <Toolbar>
                        <Typography className="name" variant="h6">Marcel Mendes</Typography>
                        <Typography className="nav-right" variant="h6"><a href='#about-me'>About Me</a></Typography>
                        <Typography className="nav-right" variant="h6"><a href='#projects'>Projects</a></Typography>
                    </Toolbar>
                </AppBar>
            </ElevationScroll>
            <Toolbar/>
        </React.Fragment>
    );
}